import { css } from '@emotion/css'
import { minScreen } from 'utils/mediaQueries'
import { Color } from 'utils/variables'
import { buttonInteraction } from 'utils/mixin'

export const wrap = css`
  width: calc(100vw - 52px);
  position: fixed;
  top: 15px;
  right: 26px;
  font-family: 'Hiragino Kaku Gothic Pro';
  opacity: 0;
  transform: translateY(-120%);
  transition: opacity 0.5s, transform 0.5s;
  z-index: 10000;
  ${minScreen('md')} {
    width: 322px;
  }
`;
export const wrapActive = css`
  opacity: 1;
  transform: translateY(0);
`;

export const closeButton = css(
  buttonInteraction,
  css`
  width: 29px;
  height: 29px;
  margin: 0 0 2px auto;
  position: relative;
  cursor: pointer;
`
);

export const body = css`
  width: 100%;
  padding: 15px;
  background: linear-gradient(147.36deg, #F3696E 21.73%, #F8A902 133.08%);
  border: 2px solid ${Color.White};
  border-radius: 14px;
  box-shadow: 0px 4.44286px 22.2143px rgba(203, 111, 60, 0.5);
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const icon = css`
  stroke:  ${Color.White};
`;

export const text = css`
  margin: 0;
  color: ${Color.White};
  flex: 1;
  font-size: 14px;
  font-weight: 600;
  line-height: 19px;
`;

export const link = css`
  width: 85px;
  height: 33px;
  background: ${Color.White};
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  text-decoration: none;
`;